import React from 'react';

const JOBS =  [
    {
        text: "Empleado/a",
        value: "RD"
    },
    {
        text: "Monotributista (servicios)",
        value: "MS",
        category : [
            {
                text: "A",
                value: "A"
            },
            {
                text: "B",
                value: "B"
            },
            {
                text: "C",
                value: "C"
            },
            {
                text: "D",
                value: "D"
            },
            {
                text: "E",
                value: "E"
            },
            {
                text: "F",
                value: "F"
            },
            {
                text: "G",
                value: "G"
            },
            {
                text: "H",
                value: "H"
            }
        ]
    },
    {
        text: "Monotributista (ventas)",
        value: "MO",
        category: [
            {
                text: "A",
                value: "A"
            },
            {
                text: "B",
                value: "B"
            },
            {
                text: "C",
                value: "C"
            },
            {
                text: "D",
                value: "D"
            },
            {
                text: "E",
                value: "E"
            },
            {
                text: "F",
                value: "F"
            },
            {
                text: "G",
                value: "G"
            },
            {
                text: "H",
                value: "H"
            },
            {
                text: "I",
                value: "I"
            },
            {
                text: "J",
                value: "J"
            },
            {
                text: "K",
                value: "K"
            }
        ]
    },
    {
        text: "Responsable Inscripto",
        value: "RE"
    },
    {
        text: "Jubilado/a",
        value: "JU"
    },
    {
        text: "Otra situación laboral",
        value: "OT"
    }
]


export const choices = {
    apptype: {
        CP: [
            {
                description: "",
                text: "",
                value: "CP",
            }
        ],
        CE: [
            {
                description: "Podés refinanciar deudas de cualquier tipo (tarjetas, préstamos, planes de ahorro, u otros).",
                text: "Refinanciar deudas",
                value: "CD",
            },
            {
                description: "Podés usarlo para refaccionar, remodelar o ampliar tu vivienda.",
                text: "Remodelar mi vivienda",
                value: "RO",
            },
            {
                description: "Podés cancelar tu plan de ahorro o crédito prendario por un préstamo más barato y empezar a ahorrar todos los meses.",
                text: "Cancelar plan de ahorro / Crédito prendario",
                value: "CC",
            },
            {
                description: "Podés invertir el dinero en lo que quieras: Un negocio propio, de un familiar, de un amigo o cualquier cosa que tengas en mente para ganar más plata.",
                text: "Invertir / Capital de trabajo",
                value: "IN",
            },
            {
                description: "¡Los créditos son de libre destino! Seleccioná esta opción si necesitás el préstamo para un destino no contemplado en las opciones anteriores.",
                text: "Otro destino",
                value: "OT",
            },
            {
                description: "",
                text: "Comprar un auto",
                value: "CP",
                hidden: true,
            },
            {
                description: "",
                text: "Viajar",
                value: "TR",
                hidden: true,
            },
            {
                description: "",
                text: "Reparar el auto",
                value: "RC",
                hidden: true,
            },
        ],
        HD: [
            {
                description: "Refinanciá y consolidá tus deudas con Agilis.",
                property_type: PROPERTY_TYPES,
                text: "Cancelación de deudas",
                value: "CD",
            },
            {
                description: "Créditos para potenciar tu negocio.",
                property_type: PROPERTY_TYPES,
                text: "Capital de trabajo",
                value: "IN",
                hidden: true,
            },
            {
                description: "Créditos para potenciar tu negocio.",
                property_type: PROPERTY_TYPES,
                text: "Capital de trabajo para Pymes",
                value: "PY",
            },
            {
                description: "Remodelá o ampliá tu casa.",
                property_type: PROPERTY_TYPES_SHORT,
                text: "Refacción",
                value: "RO",
            },
            {
                description: "Créditos para consumo o inversión personal.",
                property_type: PROPERTY_TYPES,
                text: "Inversión personal",
                value: "OT",
            },
            {
                description: <span>Te financiamos <b>hasta un 40% del valor</b> de la propiedad.</span>,
                property_type: PROPERTY_TYPES,
                text: "Compra de un inmueble",
                value: "BH",
            },
            {
                description: "",
                text: "Reforma de vivienda única",
                value: "RE",
                hidden: true,
            },
            {
                description: "¡No malvendas tu inmueble para resolver tus necesidades financieras!",
                property_type: PROPERTY_TYPES,
                text: "Adelanto de venta",
                value: "BL",
            },

        ],
        SP: [
            {
                property_type: PROPERTY_TYPES_SHORT,
                text: "Vivienda única",
                value: "BU",
            },
            {
                property_type: PROPERTY_TYPES_SHORT,
                text: "Segunda vivienda",
                value: "BO",
            },
            {
                property_type: PROPERTY_TYPES_SHORT,
                text: "Oficina, consultorio o local comercial",
                value: "BC",
            },
        ],
    },
    civil_status: [
        {
            text: "Soltero",
            value: "SI"
        },
        {
            text: "Casado",
            value: "MA"
        },
        {
            text: "Unión convivencial",
            value: "CO"
        },
        {
            text: "Viudo",
            value: "WI"
        },
        {
            text: "Divorciado",
            value: "DI"
        }
    ],

    jobs: JOBS,

    jobsStaff: [...JOBS, {
                text: "Otros ingresos justificados",
                value: "JF"
            }
    ],

    owner: [
        {
            text: "Está a mi nombre",
            value: "OW"
        },
        {
            text: "Está a mi nombre y de mi cónyuge",
            value: "CO"
        },
        {
            text: "Está a mi nombre y de un 3ro",
            value: "TH"
        },
        {
            text: "Está a nombre de otra persona",
            value: "OT"
        }
    ],
    purposes: [
        {
            text: "Particular",
            value: "PR"
        },
        {
            text: "Comercial",
            value: "CO"
        },
        {
            text: "Transporte de pasajeros",
            value: "PS"
        }
    ],
    reasons: [
        {
            text: "Tarjetas",
            value: "CC"
        },
        {
            text: "Préstamo personal",
            value: "PL"
        },
        {
            text: "Préstamo hipotecario",
            value: "ML"
        },
        {
            text: "Préstamo prendario",
            value: "PZ"
        },
        {
            text: "Deudas no bancarias",
            value: "ND"
        },
        {
            text: "Otro",
            value: "OT"
        }

    ],
    relations: [
        {
            text: "Es mi padre/madre",
            value: "PA"
        },
        {
            text: "Es mi hermano/a",
            value: "SI"
        },
        {
            text: "Es mi hijo/a",
            value: "SO"
        },
        {
            text: "Es mi cónyuge",
            value: "SP"
        },
        {
            text: "Es mi concubino/a",
            value: "CO"
        },
        {
            text: "Otro",
            value: "OT"
        }
    ],
    zones: [
        {
            text: "Capital Federal",
            value: "CA"
        },
        {
            text: "Gran Buenos Aires",
            value: "GB"
        },
        {
            text: "La Plata",
            value: "LP"
        },
        {
            text: "Rosario",
            value: "RO"
        },
        {
            text: "Otro",
            value: "OT"
        },
        {
            text: "Pcia. de Buenos Aires",
            value: "BA"
        },
        {
            text: "Córdoba",
            value: "CO"
        },
        {
            text: "Mendoza",
            value: "ME"
        },
    ],
    zonesCar: [
        {
            text: "Capital Federal",
            value: "CA"
        },
        {
            text: "Gran Buenos Aires",
            value: "GB"
        },
        {
            text: "Provincia de Buenos Aires",
            value: "BA"
        },
        {
            text: "Rosario",
            value: "RO"
        },
        {
            text: "Otro",
            value: "OT"
        },
    ],
    zonesHome: [
        {
            text: "Capital Federal",
            value: "CA"
        },
        {
            text: "GBA Norte",
            value: "GN"
        },
    ],
}

const PROPERTY_TYPES = [
    {
        text: "Departamento",
        value: "AP",
    },
    {
        text: "Casa",
        value: "HO",
    },
    {
        text: "PH",
        value: "PH",
    },
    {
        text: "Oficina",
        value: "OF",
    },
    {
        text: "Local Comercial",
        value: "SH",
    },
    {
        text: "Consultorio",
        value: "DR",
    },
    {
        text: "Otro",
        value: "OT",
    }
]

const PROPERTY_TYPES_SHORT =[
    {
        text: "Oficina",
        value: "OF",
    },
    {
        text: "Local Comercial",
        value: "SH",
    },
    {
        text: "Consultorio",
        value: "DR",
    }
]
